const url = new URL(window.location.href);
const defaultView = 'd2g';

export const view = url.searchParams.get('view') || defaultView;